import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { SymbolCatalog } from "../engine";

const Ctx = createContext(null);
const POLL_MS = 15000;
const DEFAULT_FILTERS = { market: "all", direction: "all", minScore: 60, bos: false, choch: false, fvg: false, liquidity: false, tickDominance: false };

// R.I.O scanner results come from the SERVER-SIDE scanner worker (GET /api/scanner) — the same engine bundle the chart
// uses, running continuously on the backend. This context only polls, filters and exposes the live match count.
export function ScannerProvider({ children }) {
  const [filters, setFilters] = useState(() => ({ ...DEFAULT_FILTERS, ...JSON.parse(localStorage.getItem("rio.scanner") || "{}") }));
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { localStorage.setItem("rio.scanner", JSON.stringify(filters)); }, [filters]);

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/scanner"); setRows(data.results); setStatus(data.status); setError(null); }
    catch (e) { setError(e.response?.data?.detail || e.message); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { refresh(); const id = setInterval(refresh, POLL_MS); return () => clearInterval(id); }, [refresh]);

  const matches = useMemo(() => rows.filter((r) =>
    (filters.market === "all" || SymbolCatalog.get(r.symbol)?.market === filters.market) &&
    (filters.direction === "all" || r.direction === filters.direction) && r.score >= filters.minScore &&
    (!filters.bos || r.bos) && (!filters.choch || r.choch) && (!filters.fvg || r.fvg) && (!filters.liquidity || r.liquidity) && (!filters.tickDominance || r.tickDominance)
  ).sort((a, b) => b.score - a.score), [rows, filters]);

  return <Ctx.Provider value={{ rows, matches, filters, setFilters, status, error, loading, refresh }}>{children}</Ctx.Provider>;
}

export const useScanner = () => useContext(Ctx);
